module.exports = __webpack_public_path__ + "static/media/dn.9edb039a.svg";